import React from "react";
import "./CoverPlaceholder.scss";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as InfoIcon } from "src/images/info-new.svg";
import { updateModeParam } from "src/app/CreatorShowcase/utils";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { IDH_BRAND_COLOR } from "src/constants/idhBrandColor";
import { ReactComponent as PlaceholderBoxes } from "./placeholder.svg";
import { ShowcaseSeparator } from "../../../../components/ShowcaseSeparator/ShowcaseSeparator";

function CoverPlaceholder() {
  const history = useHistory();

  const summaryPlacement = useSelector(
    (state) => state.showcaseReducer.summaryPlacement,
  );
  const placement = summaryPlacement.value;

  const identity = useSelector((state) => state.mainReducer.identity);
  const primaryColor =
    identity.wsWorkspace?.customPrimaryColor || IDH_BRAND_COLOR;

  return (
    <div className="cover-placeholder">
      <ShowcaseSeparator hideInfo />

      <div className="cover-placeholder__image">
        <PlaceholderBoxes />
      </div>
      <div className="cover-placeholder__info">
        <InfoIcon />
        <div className="cover-placeholder__info-bold">
          <IDHFormattedMessage
            id="ws_here_will_be_content_of_showcase"
            defaultMessage="Here will be the content of the showcase"
          />
          .
        </div>
        <div className="cover-placeholder__info-text">
          <IDHFormattedMessage
            id="ws_to_edit_this_part_go_to"
            defaultMessage="To edit this part go to the"
          />
          &nbsp;
          <span
            className="cover-placeholder__info-text-underline"
            onClick={() => updateModeParam(history, "tab", "creators")}
          >
            <IDHFormattedMessage id="ws_creators" defaultMessage="Creators" />
          </span>
          &nbsp;
          <IDHFormattedMessage id="ws_tab" defaultMessage="tab" />.
        </div>
      </div>

      <ShowcaseSeparator
        className="cover-placeholder__bottom-separator"
        primaryColor={placement !== "bottom" ? primaryColor : undefined}
      />
    </div>
  );
}

export default CoverPlaceholder;
